module.exports = __webpack_public_path__ + "static/media/Manual.994b3ea5.svg";